import { render, staticRenderFns } from "./WithdrawalList.vue?vue&type=template&id=2747cfa2&scoped=true"
import script from "./WithdrawalList.vue?vue&type=script&lang=js"
export * from "./WithdrawalList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalList.vue?vue&type=style&index=0&id=2747cfa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2747cfa2",
  null
  
)

export default component.exports